import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/apps",
  },
  {
    path: "/apps",
    name: "apps",
    component: () => import("@/views/apps/index.vue"),
  },
  {
    path: "/app/:id",
    name: "app",
    props(route) {
      return {
        id: route.params.id,
      };
    },
    component: () => import("@/views/app/index.vue"),
  },
  {
    path: "/favorite",
    name: "favorites",
    component: () => import("@/views/favorite/index.vue"),
  },
  {
    path: "/favorite/:id",
    name: "favorite",
    props(route) {
      return {
        id: route.params.id,
      };
    },
    component: () => import("@/views/favorite/index.vue"),
  },
  {
    path: "/play/:id",
    name: "play",
    props(route) {
      return {
        id: route.params.id,
      };
    },
    component: () => import("@/views/play/index.vue"),
  },
  {
    path: "/admin/applications",
    name: "admin-applications",
    component: () => import("@/views/admin/applications/index.vue"),
  },
  {
    path: "/admin/webgl-player",
    name: "admin-webgl-player",
    component: () => import("@/views/admin/webgl-player/index.vue"),
  },
  {
    path: "/admin/permissions",
    name: "admin-permissions",
    component: () => import("@/views/admin/permissions/index.vue"),
  },
  {
    path: "/admin/logs",
    name: "admin-logs",
    component: () => import("@/views/admin/logs/index.vue"),
  },
  {
    path: "/no-access",
    name: "no-access",
    component: () => import("@/views/no-access/index.vue"),
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (!store.getters["user/hasAccess"]) {
    if (to.path !== "/no-access") next("/no-access");
    else next();
    return;
  }

  if (to.path === "/no-access") {
    next("/apps");
    return;
  }

  if (
    ["/admin/permissions", "/admin/logs"].includes(to.path) &&
    !store.getters["user/isAdmin"]
  ) {
    next("/apps");
    return;
  }

  if (
    to.name === "admin-webgl-player" &&
    !store.getters["user/isAdmin"]
  ) {
    next("/apps");
    return;
  }

  next();
});

export default router;
